import { Filters } from '../utils/pageConfig/Types';

export interface WeeklyMonthlyFeatures {
  weekly: Filters[];
  monthly: Filters[];
}

export enum ColumnHeader {
  brand = 'brand',
  retailerShareForBrandRevenue = 'retailerShareForBrandRevenue',
  brandShareForRetailerRevenue = 'retailRevenueShare',
  brandRevenue = 'brandRevenue',
  brandRevenueChange = 'brandRevenueChange',
  brandRevenueShare = 'brandRevenueShare',
  brandRevenueShareChange = 'brandRevenueShareChange',
  retailerRevenue = 'retailerRevenue',
  retailerRevenueChange = 'retailerRevenueChange',
  retailerRevenueShare = 'retailerRevenueShare',
  retailerRevenueShareChange = 'retailerRevenueShareChange',
  retailerShareForBrandUnits = 'retailerShareForBrandUnits',
  brandShareForRetailerUnits = 'brandShareForRetailerUnits',
  brandUnits = 'brandUnits',
  brandUnitsChange = 'brandUnitsChange',
  brandUnitsShare = 'brandUnitsShare',
  brandUnitsShareChange = 'brandUnitsShareChange',
  retailerUnits = 'retailerUnits',
  retailerUnitsChange = 'retailerUnitsChange',
  retailerUnitsShare = 'retailerUnitsShare',
  retailerUnitsShareChange = 'retailerUnitsShareChange',
}

export const ColumnHeaderDisplayName = {
  [ColumnHeader.brand]: 'Brand',
  [ColumnHeader.retailerShareForBrandRevenue]: '{retailer} Share of Brand Revenue',
  [ColumnHeader.brandShareForRetailerRevenue]: 'Brand Share of {retailer} Revenue',
  [ColumnHeader.brandRevenue]: 'Brand Revenue',
  [ColumnHeader.brandRevenueChange]: 'Brand Revenue Change',
  [ColumnHeader.brandRevenueShare]: 'Brand Revenue Share',
  [ColumnHeader.brandRevenueShareChange]: 'Brand Revenue Share Change',
  [ColumnHeader.retailerRevenue]: '{retailer} Revenue',
  [ColumnHeader.retailerRevenueChange]: '{retailer} Revenue Change',
  [ColumnHeader.retailerRevenueShare]: '{retailer} Revenue Share',
  [ColumnHeader.retailerRevenueShareChange]: '{retailer} Revenue Share Change',
  [ColumnHeader.retailerShareForBrandUnits]: '{retailer} Share of Brand Units',
  [ColumnHeader.brandShareForRetailerUnits]: 'Brand Share of {retailer} Units',
  [ColumnHeader.brandUnits]: 'Brand Units',
  [ColumnHeader.brandUnitsChange]: 'Brand Units Change',
  [ColumnHeader.brandUnitsShare]: 'Brand Units Share',
  [ColumnHeader.brandUnitsShareChange]: 'Brand Units Share Change',
  [ColumnHeader.retailerUnits]: '{retailer} Units',
  [ColumnHeader.retailerUnitsChange]: '{retailer} Units Change',
  [ColumnHeader.retailerUnitsShare]: '{retailer} Units Share',
  [ColumnHeader.retailerUnitsShareChange]: '{retailer} Units Share Change',
};
